module.exports = __webpack_public_path__ + "static/media/cq_documento_letto.1ae9509d.svg";